import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CreateTeamFormik from './CreateTeamFormik';

interface CreateTeamOffcanvasProps {
    show: boolean;
    setShow: (show: boolean) => void;
    onCreated: () => Promise<void>;
}

const CreateTeamOffcanvas = ({ show, setShow, onCreated }: CreateTeamOffcanvasProps) => {
    const { t } = useTranslation(['Warehouses']);

    const handleClose = () => setShow(false);

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('createTeam.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <CreateTeamFormik setShow={setShow} onCreated={onCreated} />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default CreateTeamOffcanvas;
